import { css } from '@emotion/core'

export const buttonContainer = css`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const signupButton = css`
  width: 100%;
`

export const requiredFieldsNote = css`
  color: #00E676;
  margin-bottom: 10px;
  font-style: italic;
  font-size: 11px;
`

export const styles = {
  requiredFieldsNote: {
    color: '#999',
    marginBottom: '10px',
  },
}

export const smallerLabels = css`
  label {
    font-size: 11px;
  }
  
  input, select, textarea {
    font-size: 11px;
  }
`
